import {
  PLACEMENT__BOTTOM_END
} from '../components/Layout/Wrappers/StyledTooltip';

const MatchPageUI = {
  SelectedJobExtendedFilter: {
    label: 'Extended Filter',
    title: 'Enable extended filters: Rating and Stages',
    placement: PLACEMENT__BOTTOM_END
  },
  JobsDropdown: {
    label: 'Jobs',
    title: 'Select a similar job to filter candidates matched to that role',
    placement: PLACEMENT__BOTTOM_END,
  }
};
export default MatchPageUI;
